import { render, staticRenderFns } from "./FairViewPage.vue?vue&type=template&id=2708e0b5"
import script from "./FairViewPage.vue?vue&type=script&lang=js"
export * from "./FairViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports